import React from 'react';

import classNames from 'classnames';

import {CloudinaryImage} from 'components/cloudinaryImage/cloudinaryImage';

import {AccessoryImageType} from '../../types';

import s from './newCartAccessoryMedia.scss';

export type PropsType = {
    images: Array<AccessoryImageType>;
    alt: string;
    activeImageIndex: number;
    changeActiveIndex: (index: number) => void;
};

/**
 * Cart accessory tooltip image
 * @param {PropsType} props accessory images props
 * @returns {Node} accessory media component
 */
export const NewCartAccessoryMedia = ({
    activeImageIndex,
    alt,
    changeActiveIndex,
    images,
}: PropsType) => {
    return (
        <div className={s.media}>
            <div className={s.mainImage}>
                <CloudinaryImage
                    alt={alt}
                    height={370}
                    src={images[activeImageIndex].full.src}
                    width={370}
                />
            </div>
            {images.length > 1 && (
                <div className={s.imagesRow}>
                    {images.map((img: {thumb: {src: string}}, i: number) => (
                        <CloudinaryImage
                            className={classNames(s.imageThumb, {
                                [s.activeImageThumb]: i === activeImageIndex,
                            })}
                            alt={alt}
                            key={img.thumb.src}
                            onClick={() => changeActiveIndex(i)}
                            src={img.thumb.src}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};
